import type { ReactElement } from "react";
import type { GlyphKey } from "./engine-config";

/** The path data below is byte-for-byte equivalent to the supplied v1.0 JS. */
export function Glyph({ name }: { readonly name: GlyphKey }): ReactElement {
  if (name === "ject") {
    return (
      <>
        <path
          d="M150 104 L150 196 M114 132 C132 130 139 140 150 150 C161 140 168 130 186 132 M114 168 C132 170 139 160 150 150 C161 160 168 170 186 168"
          stroke="currentColor"
          strokeWidth="7"
          strokeLinecap="round"
          fill="none"
        />
        <circle cx="150" cy="150" r="6" fill="currentColor" />
      </>
    );
  }
  if (name === "histor") {
    return (
      <>
        <path
          d="M122 119 C154 103 186 121 179 150 C174 172 147 173 134 158 C125 147 130 131 147 130"
          stroke="currentColor"
          strokeWidth="7"
          strokeLinecap="round"
          fill="none"
        />
        <path
          d="M123 184 C139 174 161 174 177 184 M126 103 L174 103"
          stroke="currentColor"
          strokeWidth="6"
          strokeLinecap="round"
          fill="none"
        />
      </>
    );
  }
  if (name === "echo") {
    return (
      <>
        <path
          d="M130 126 C117 138 117 162 130 174 M151 114 C132 134 132 166 151 186 M172 126 C185 138 185 162 172 174"
          stroke="currentColor"
          strokeWidth="7"
          strokeLinecap="round"
          fill="none"
        />
        <circle cx="151" cy="150" r="5" fill="currentColor" />
      </>
    );
  }
  if (name === "aegis") {
    return (
      <>
        <path
          d="M150 105 L188 126 L178 171 L150 194 L122 171 L112 126 Z"
          stroke="currentColor"
          strokeWidth="7"
          strokeLinejoin="round"
          fill="none"
        />
        <path
          d="M150 122 L150 176 M132 141 L168 141"
          stroke="currentColor"
          strokeWidth="6"
          strokeLinecap="round"
          fill="none"
        />
      </>
    );
  }
  return (
    <>
      <path
        d="M123 178 L150 104 L177 178 Z"
        stroke="currentColor"
        strokeWidth="7"
        strokeLinejoin="round"
        fill="none"
      />
      <path
        d="M128 148 L172 148 M140 126 L160 126"
        stroke="currentColor"
        strokeWidth="6"
        strokeLinecap="round"
        fill="none"
      />
      <circle cx="150" cy="148" r="5" fill="currentColor" />
    </>
  );
}
